import { render } from "./retweet.vue?vue&type=template&id=7640a585"
const script = {}
script.render = render

export default script